export const showQR = ()=>{
    document.querySelector(".landing img").classList.add("d-none")
    document.querySelector(".landing .buttons-container").classList.add("d-none")
    document.querySelector(".App").classList.remove("d-none")
}

export const showManual = ()=>{
    document.querySelector(".landing img").classList.add("d-none")
    document.querySelector(".landing .buttons-container").classList.add("d-none")
    document.querySelector(".manual-register").classList.remove("d-none")
}

const base = window.location.hostname === "localhost"
    ? "https://savethechildrenmx.org"
    : "https://savethechildrenmx.org";

export const getPayments = async ()=>{
    await fetch(`${base}/api/event/3/getPayments`, {
        method: "GET",
    }).then(response => response.json()).then(responseJson => {

        responseJson.sort((a, b) => {
            return Number(a.event_table.name) - Number(b.event_table.name);
        });

        responseJson.forEach((item) => {
            item.invitados.forEach((element) => {
                if(item.event_table.name > 0){
                    var container = document.createElement("div");
                    container.classList.add("item");

                    var propietario = document.createElement("div")
                    propietario.classList.add("propietario");
                    item.comprador = item.comprador.toUpperCase()
                    item.comprador = item.comprador.replaceAll("Á","A")
                    item.comprador = item.comprador.replaceAll("É","E")
                    item.comprador = item.comprador.replaceAll("Í","I")
                    item.comprador = item.comprador.replaceAll("Ó","O")
                    item.comprador = item.comprador.replaceAll("Ú","U")
                    propietario.innerHTML = item.comprador

                    var invitado = document.createElement("div")
                    invitado.classList.add("invitado");
                    element = element != null ? element.toUpperCase():""
                    element = element.replaceAll("Á","A")
                    element = element.replaceAll("É","E")
                    element = element.replaceAll("Í","I")
                    element = element.replaceAll("Ó","O")
                    element = element.replaceAll("Ú","U")
                    invitado.innerHTML = element

                    var mesa = document.createElement("div")
                    mesa.textContent = "Mesa " + item.event_table.name


                    var registrar = document.createElement("button")
                    registrar.textContent = "Registrar"
                    registrar.setAttribute("payment",item.id);
                    registrar.onclick = registrarAsistencia

                    container.appendChild(propietario);
                    container.appendChild(invitado);
                    container.appendChild(mesa);
                    container.appendChild(registrar);

                    document.querySelector(".list").appendChild(container);
                }
            })
        })
    })

    document.querySelector("input").focus()
}

const registrarAsistencia = async (evt)=>{
    var asistentes = prompt("Número de asistentes")
    var validate = new RegExp("^[0-9]{1,2}$")
    while(!validate.test(asistentes)){
        asistentes = prompt("Número de asistentes: ")
    }

    const response = await fetch(`${base}/api/events/payment/checkin?id=${evt.target.getAttribute("payment")}&asistentes=${asistentes}`, {
        method: "GET",
    });

    const responseData = await response.json();

    if (responseData.status !== 1) {
        alert(responseData.message)
    }else{
        alert("Registro encontrado. \nMesa número: " + responseData.compra.event_table.name+"\nComprador: "+responseData.compra.comprador)
    }


    document.querySelector(".list").innerHTML = "";
    document.querySelector("input").value = ""
    document.querySelector("input").focus()
    getPayments()

}

export const filter = async (evt) =>{
    if (evt.key.localeCompare("Enter") !== 0){
        if (evt.target.value.length === 0){
            document.querySelectorAll(".list .item").forEach((item)=>{
                item.classList.remove("d-none")
            })
        }else{
            document.querySelectorAll(".propietario").forEach((item)=>{
                if(evt.target.value.length > 0){
                    if (item.textContent.toUpperCase().includes(evt.target.value.toUpperCase()) || item.nextElementSibling.textContent.toUpperCase().includes(evt.target.value.toUpperCase())){
                        item.parentElement.classList.remove("d-none")
                    }else{
                        item.parentElement.classList.add("d-none")
                    }
                }else{
                    item.classList.remove("d-none")
                }
            })
        }
    }else{
        var compra = evt.target.value.split(" ")[1]

        var asistentes = prompt("Número de asistentes")
        var validate = new RegExp("^[0-9]{1,2}$")
        while(!validate.test(asistentes)){
            asistentes = prompt("Número de asistentes: ")
        }


        const response = await fetch(`${base}/api/events/payment/checkin?id=${compra}&asistentes=${asistentes}`, {
            method: "GET",
        });
        const responseData = await response.json();

        alert("Registro encontrado. \nMesa número: " + responseData.compra.event_table.name+"\nComprador: "+responseData.compra.comprador)
        document.querySelectorAll(".list .item").forEach((item)=>{
            item.classList.remove("d-none")
        })

        evt.target.value = "";

        window.location.reload()
    }
}